import { DialogController } from "aurelia-dialog";
import { inject } from "aurelia-framework";

import { IDialogOptions } from "../../../interfaces/i-dialog";

@inject(DialogController)
export class ServerErrorDialog {
    public controller: DialogController;
    public options: IDialogOptions = {
        title: "Server Error",
        description: "",
        type: "error",
        icon: "far fa-times-circle"
    };

    public constructor(controller: DialogController) {
        this.controller = controller;
    }

    public activate(options: any) {
        Object.assign(this.options, options);
    }
}
